<template>
    <div>
        <div class="card">
            <datatable tableId="parametersTable" :columns="columns" :data="parameters" :ignoreCache="true"
                :showLoading="parameters === null" />
        </div>
    </div>
</template>
<script>
import Datatable from '../../components/Datatable.vue';
export default {
    components: { Datatable },
    data() {
        return {
            columns: [
                { data: "name" },
                { data: "description" },
                { data: "type" },
                { data: "required" },
                { data: "read_only", title: "read only" },
                { data: "value" }
            ]
        };
    },
    props: ["parameters"]
};
</script>
<style></style>
